<template>
  <!-- Modal -->
  <div>
    <div
      class="modal fade"
      id="downloadTemplateModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content custom-modal">
          <!-- Header -->
          <div class="modal-header">
            <h4 class="modal-title">Download Template</h4>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span>&times;</span>
            </button>
          </div>

          <!-- Body -->
          <div class="modal-body">
            <p class="modal-description">
              Download template surat untuk diisi dan ditandatangani oleh klien.
            </p>

            <!-- Card 1 -->
            <component-guard :requiredPermissions="['29.1']">
              <div
                class="template-card"
                :class="[
                  selectedDocument === 'surat-permohonan' ? 'selected' : '',
                ]"
                @click="selectDocument('surat-permohonan')"
              >
                <div class="template-icon">
                  <img src="~@/assets/icon/doc.svg" alt="doc" />
                </div>

                <div class="template-content">
                  <div class="template-title">Template Surat Permohonan</div>

                  <div class="template-format">Format: WORD</div>

                  <div class="template-description">
                    Template ini berisi format standar surat permohonan yang
                    harus dilengkapi oleh klien.
                  </div>
                </div>
              </div>
            </component-guard>

            <!-- Card 2 -->
            <component-guard :requiredPermissions="['30.1']">
              <div
                class="template-card"
                :class="[
                  selectedDocument === 'surat-persetujuan' ? 'selected' : '',
                ]"
                @click="selectDocument('surat-persetujuan')"
              >
                <div class="template-icon">
                  <img src="~@/assets/icon/doc.svg" alt="doc" />
                </div>

                <div class="template-content">
                  <div class="template-title">Template Surat Persetujuan</div>

                  <div class="template-format">Format: WORD</div>

                  <div class="template-description">
                    Template ini berisi format standar surat persetujuan setelah
                    negosiasi dengan klien.
                  </div>
                </div>
              </div>
            </component-guard>
          </div>

          <!-- Footer -->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal"
            >
              Batal
            </button>

            <button
              type="button"
              class="btn btn-primary"
              @click="downloadSelected"
              :disabled="disabledAction"
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ComponentGuard } from "@/components/Permissions";

export default {
  name: "DownloadTemplateDoc",
  components: {
    ComponentGuard,
  },
  data() {
    return {
      selectedDocument: null,
    };
  },

  computed: {
    ...mapGetters("rentAdjustment", {
      transferUnitId: "getId",
      transferUnitStatus: "getStatus",
      ltCode: "getLtCode",
    }),
    disabledAction() {
      return this.transferUnitStatus !== "verification";
    },
  },

  methods: {
    ...mapActions("rentAdjustment", ["downloadTemplateApplicationDocument"]),
    selectDocument(type) {
      if (this.disabledAction) return;
      this.selectedDocument = type;
    },
    downloadSelected() {
      if (this.selectedDocument) {
        this.downloadTemplateApplicationDocument({
          transferUnitId: this.transferUnitId,
          type: this.selectedDocument,
          ltCode: this.ltCode,
        });
      }
      //   $(`#downloadTemplateModal`).modal("hide");
    },
  },
};
</script>

<style scoped>
.custom-modal {
  border: none;
  border-radius: 16px;
  overflow: hidden;
}

.modal-header {
  padding: 24px;
  border-bottom: 1px solid #e9ecef;
}

.modal-title {
  font-size: 32px;
  font-weight: 600;
  color: #374151;
}

.close {
  font-size: 28px;
  color: #6b7280;
  opacity: 1;
}

.modal-body {
  padding: 24px;
}

.modal-description {
  margin-bottom: 20px;
  color: #6b7280;
  font-size: 15px;
  line-height: 1.5;
}

.template-card {
  display: flex;
  gap: 16px;

  padding: 16px;
  margin-bottom: 16px;

  border: 1px solid #d9dee7;
  border-radius: 8px;

  cursor: pointer;
  transition: all 0.2s;

  background-color: #f8f9fa;
}

.template-icon {
  width: 24px;
  flex-shrink: 0;
  text-align: center;
}

.template-icon i {
  font-size: 18px;
  color: #4b5563;
}

.template-title {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.template-format {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 8px;
}

.template-description {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e9ecef;
}

.modal-footer .btn {
  min-width: 90px;
  border-radius: 6px;
}

.template-card.selected {
  border: 1px solid #92d4fe;
  background-color: #eff8ff;
}

.btn {
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 20px;
}

.btn:disabled {
  background-color: #d1d5dc;
  cursor: not-allowed;
  color: #ffffff;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/RentAdjustment/CustomComponent/DownloadTemplateDoc.vue